import { ApolloProvider } from '@apollo/client';
import { ResetCSS } from 'common/assets/css/style';
import { darkTheme } from 'common/theme/dark/darkTheme';
import { lightTheme } from 'common/theme/light/lightTheme';
import { GlobalStyle } from 'containers/app.style';
import { apolloClient } from 'graphql/client';
import React, { FC, PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';
import { useDarkMode } from 'hooks/useDarkMode';
import WalletProvider from 'containers/WalletProvider/WalletProvider';

const Contexts: FC<PropsWithChildren> = ({ children }) => {
  const darkMode = useDarkMode();
  const theme = darkMode.isDarkMode ? darkTheme : lightTheme;
  return (
    <ThemeProvider theme={theme}>
      <WalletProvider>
        <ApolloProvider client={apolloClient}>
          <ResetCSS />
          <GlobalStyle />
          {children}
        </ApolloProvider>
      </WalletProvider>
    </ThemeProvider>
  );
};

export default Contexts;
